import * as React from "react";
import { forwardRef } from "react";
const SvgMenuSelect = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 4, height: 18, viewBox: "0 0 4 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4 18C1.79086 18 1.56562e-07 16.2091 3.49691e-07 14L1.22392e-06 4C1.41705e-06 1.79086 1.79086 -1.93129e-07 4 0L4 18Z", fill: "#11466C" }));
const ForwardRef = forwardRef(SvgMenuSelect);
export default ForwardRef;
